import { Col, Container, Row } from "reactstrap";
import styles from "./ShippingCarrierDetail.module.scss";
import GeneralBackButton from "../../../../common/AdminCommonComponents/Buttons/GeneralBackButton/GeneralBackButton";
import InfoCard from "../../../../common/AdminCommonComponents/InfoCard/InfoCard";
import ColoredHeader from "../../../../common/AdminCommonComponents/ColoredHeading/ColoredHeader";
import GradientBarChart from "../../../../common/AdminCommonComponents/Graphs/GradientBarChart/GradientBarChart";
import { TfiStatsUp, TfiStatsDown } from "react-icons/tfi";
import LineChart from "../../../../common/AdminCommonComponents/Graphs/LineChart/LineChart";
import { RiBriefcase4Line } from "react-icons/ri";
import ChartHeader from "../../../../common/AdminCommonComponents/Graphs/ChartHeader/ChartHeader";

const ShippingCarrierDetail = () => {
    const partnerDetails = [
        { label: "Name", value: "#1234" },
        { label: "On-time delivery", value: "75%" },
        { label: "Average Transit Time", value: "2" },
        { label: "Orders Delivered", value: "$50.00" },
        { label: "Damaged Packages", value: "$50.00" },
        { label: "Lost Packages", value: "Shipped" },
    ];

    const chartData = [
        {
            name: "M",
            uv: 4000,
            pv: 2400,
            amt: 2400,
        },
        {
            name: "T",
            uv: 3000,
            pv: 1398,
            amt: 2210,
        },
        {
            name: "W",
            uv: 2000,
            pv: 9800,
            amt: 2290,
        },
        {
            name: "T",
            uv: 2780,
            pv: 3908,
            amt: 2000,
        },
        {
            name: "F",
            uv: 1890,
            pv: 4800,
            amt: 2181,
        },
        {
            name: "S",
            uv: 2390,
            pv: 3800,
            amt: 2500,
        },
        {
            name: "S",
            uv: 3490,
            pv: 4300,
            amt: 2100,
        },
    ];

    return (
        <div className={styles.mainContainer}>
            <Container fluid className={styles.shippingCarrierWrapper}>
                <GeneralBackButton />
                <h4 className={styles.mainHeading}>Shipping Carrier Performnace</h4>

                <Row className="g-0">
                    <Col xl={6} xxl={4}>
                        <InfoCard title="Carrier Details" headerColor="#FBBD34" data={partnerDetails} />
                    </Col>
                </Row>

                <div className="mt-4 mb-3">
                    <ColoredHeader title="Performance" headerColor="#41B8E4" />
                </div>

                <Row className="g-0 mb-4 row-gap-4">
                    <Col xl={4} lg={6} className="pe-lg-3">
                        <div className={styles.graphContainer}>
                            <ChartHeader label="Revenue" value="$8900.70" Icon={TfiStatsUp} color="#ABAEB7" />
                            <GradientBarChart
                                uniqueId="revenue"
                                data={chartData}
                                gradientFrom="#CAD7FF"
                                gradientTo="#2D55B4"
                                height={250}
                            />
                        </div>
                    </Col>
                    <Col xl={4} lg={6} className="pe-xl-3">
                        <div className={styles.graphContainer}>
                            <ChartHeader label="Expenses" value="$4200.30" Icon={TfiStatsDown} color="#ABAEB7" />
                            <GradientBarChart
                                uniqueId="expense"
                                data={chartData}
                                gradientFrom="#DAC3F6"
                                gradientTo="#533A71"
                                height={250}
                            />
                        </div>
                    </Col>
                    <Col xl={4}>
                        <div className={styles.graphContainer}>
                            <ChartHeader label="Sales" value="5248" Icon={RiBriefcase4Line} color="#ABAEB7" />
                            <LineChart data={chartData} height={250} />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ShippingCarrierDetail;